module.exports = __webpack_public_path__ + "static/media/success_sound.098be089.wav";